import { render } from "./PredictionBoard.vue?vue&type=template&id=1bd8086f&scoped=true&ts=true"
import script from "./PredictionBoard.vue?vue&type=script&lang=ts"
export * from "./PredictionBoard.vue?vue&type=script&lang=ts"

import "./PredictionBoard.vue?vue&type=style&index=0&id=1bd8086f&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd8086f"]])

export default __exports__